import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { SpectralRanges } from '@ledium/types';
import { Grid } from '@mui/material';

import { DetailedIntensityInfo } from './DetailedIntensityInfo';

interface SpectrogramWithRanges {
    pfd: SpectralRanges;
    irradiance: SpectralRanges;
}

const ShowIntensityValue = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    // reason: formData is Record<string, unknown>; spectrogramRanges is set by the page before this component renders
    const spectrogramRanges = formData.spectrogramRanges as SpectrogramWithRanges | undefined;

    if (!spectrogramRanges?.pfd.sum) {
        return null;
    }

    return (
        <Grid item xs={12}>
            <DetailedIntensityInfo spectrogram={spectrogramRanges} labelKey="intensity" unit="pfd" />
            <DetailedIntensityInfo spectrogram={spectrogramRanges} unit="irradiance" />
        </Grid>
    );
};

export default ShowIntensityValue;
